<template>
	<xaoi-win ref="win" :title="(data.id?'编辑':'添加')+(data.fid?'病种':'分组')" v-model="show">
		<div class="db">
			<el-form label-width="100px" :rules="rules" :model="data" ref="edit">
				<el-form-item :label="(data.fid?'病种':'分组')+'名称'" prop="name">
					<el-input v-model="data.name" size="small"></el-input>
				</el-form-item>
				<el-form-item label="排序" prop="sort">
					<el-input v-model.number="data.sort" size="small"></el-input>
				</el-form-item>
				<el-form-item v-if="data.fid" label="是否推荐" prop="istop">
					<el-checkbox v-model="data.istop">推荐</el-checkbox>
				</el-form-item>
			</el-form>
		</div>
		<div class="buts">
			<el-button size="small" @click="show = false">取 消</el-button>
			<el-button size="small" type="primary" @click="submit()" :loading="is_load">提 交</el-button>
		</div>
	</xaoi-win>
</template>

<style lang="scss" scoped>
.db{
	padding:20px 50px 20px 30px;
}
.buts{
	text-align: right;border-top:1px solid #DCDFE6;padding:15px;
}
</style>

<script>
export default {
	data(){
		var vue = this;

		var rule_fn = function(rule, value, callback){
			if(vue.logs[rule.field]){
				callback(vue.logs[rule.field]);
				vue.logs[rule.field] = '';
				return;
			}
			callback();
		}

		return {
			show:false,
			is_load:false,
			rules: {
				name: [
					{required: true,message: "名称不能为空",trigger: "blur"},
					{validator:rule_fn}
				],
				sort: [
					{required: true,message: "排序不能为空"},
					{type: "number",message: "排序必须为数字值"},
					{validator:rule_fn}
				],
			},
			data:{
				id:'',
				fid:'',
				name:'',
				sort:0,
				istop:false
			},
			logs:{},
			init(d,fn){
				vue.ok = fn
				var ini = {
					id:'',
					fid:'',
					name:'',
					sort:0,
					istop:false
				};
				var da = d?xaoi.object_clone(d):{}
				da.istop = typeof da.istop !== 'undefined' && da.istop == 1?true:false;
				for(var i in vue.data)
					vue.data[i] = typeof da[i] !== 'undefined'?da[i]:ini[i];

				vue.show = true;
			},
			err(k,m){
				vue.logs[k] = m;
				vue.$refs.edit.validateField(k);
			},
			async submit(){
				var state = await new Promise(ok=>vue.$refs.edit.validate(ok))
				if(state){
					vue.is_load = true;
					var is = await vue.ok(vue.data)
					vue.is_load = false;
					if(is == true){
						vue.show = false;
					}
				}
			}
		}
	},
}
</script>